import { FunctionComponent, useState } from 'react';
import styles from './PreferencesForm.module.scss';
import classNames from 'classnames';
import Input from '../../../../../components/inputs/Input/Input';
import RadioSwitch from '../../../../../components/inputs/RadioSwitch/RadioSwitch';
import CheckboxTagList from '../../../../../components/inputs/CheckboxTagList/CheckboxTagList';
import Checkbox from '../../../../../components/inputs/CheckboxList/_parts/Checkbox/Checkbox';
import MainButton from '../../../../../components/buttons/MainButton/MainButton';

const DUMMY_DATA_1 = [
  { id: '0', label: 'African American' },
  { id: '1', label: 'Asian' },
  { id: '2', label: 'Blind' },
  { id: '3', label: 'Deaf' },
  { id: '4', label: 'Hispanic' },
  { id: '5', label: 'Independent' },
  { id: '6', label: 'Knows Sign Language' },
  { id: '7', label: 'LGBTQIA+' },
  { id: '8', label: 'Men' },
  { id: '9', label: 'Non-Binary/Non-Conforming' },
  { id: '10', label: 'Women' },
];

const DUMMY_DATA_2 = [
  { id: '0', label: '18-22' },
  { id: '1', label: '23-30' },
  { id: '2', label: '31-40' },
  { id: '3', label: '41-50' },
  { id: '4', label: '51-60' },
  { id: '5', label: '61-70' },
  { id: '6', label: '71-80' },
  { id: '7', label: '81+' },
];

const DUMMY_DATA_3 = [
  { id: '0', label: 'Couples dinners with matching founder/investor couples' },
  { id: '1', label: 'Mansion dinners with matching founders/investors' },
  { id: '2', label: 'I own a 5k+ sqft house and would host private dinners at my home' },
  { id: '3', label: 'Parent dinners' },
  { id: '4', label: 'Retreats' },
];

interface PreferencesFormProps {
  visualType?: 'one' | 'two';
}

const PreferencesForm: FunctionComponent<PreferencesFormProps> = ({ visualType = 'one' }) => {
  const [checkBoxState_1, setCheckBoxState_1] = useState<string[]>([]);
  const [checkBoxState_2, setCheckBoxState_2] = useState<string[]>([]);
  const [checkBoxState_3, setCheckBoxState_3] = useState<string[]>([]);
  const [checkBoxState_4, setCheckBoxState_4] = useState<string[]>([]);

  const [switchState_1, setSwitchState_1] = useState('0');
  const [switchState_2, setSwitchState_2] = useState('0');

  return (
    <form className={classNames(styles['form'], styles[`form--visual-type-${visualType}`])}>
      <div className={styles['row']}>
        <div className={classNames(styles['row__col'], styles['row__col--1'])}>
          <p className={classNames(styles['title-1'], 'text text--h3')}>
            What's your <b>phone number</b>?
          </p>

          <p className={classNames(styles['text-1'], 'text text--body-2')}>
            If there are any last-minute updates, we'll text you. 
          </p>
        </div>

        <div className={classNames(styles['row__col'], styles['row__col--2'])}>
          <Input placeholder={'000 000 000'} size="large" />
        </div>
      </div>

      <div className={styles['row']}>
        <div className={classNames(styles['row__col'], styles['row__col--1'])}>
          <p className={classNames(styles['title-1'], 'text text--h3')}>
            Do you have any dietary <b>restrictions</b> or <b>allergies</b>?
          </p>

          <p className={classNames(styles['text-1'], 'text text--body-2')}>
            Let us know if you have any dietary needs so we can ensure your meal is safe and enjoyable.
          </p>
        </div>

        <div className={classNames(styles['row__col'], styles['row__col--2'])}>
          <Input placeholder={'Enter dietary restrictions'} size="large" />
        </div>
      </div>

      <div className={styles['row']}>
        <div className={classNames(styles['row__col'], styles['row__col--1'])}>
          <p className={classNames(styles['title-1'], 'text text--h3')}>
            Dining <b>preferences</b>
          </p>

          <p className={classNames(styles['text-1'], 'text text--body-2')}>
            Would you prefer to dine with a gender-specific, ethnic-specific, or other-specific group of founders or
            investors? Please use the "Other" field to suggest ways that we can be more inclusive/accommodating.
          </p>
        </div>

        <div className={classNames(styles['row__col'], styles['row__col--2'])}>
          <p className={classNames(styles['label-1'], 'text text--body-2 text--bold')}>
            Are you open to dining with anyone of any demographic identity?
          </p>

          <RadioSwitch
            name="test"
            onChange={setSwitchState_1}
            options={[
              { label: "I'd like to choose", value: '0' },
              { label: 'Yes', value: '1' },
            ]}
            selected={switchState_1}
            className={styles['radio-switch']}
          />

          <CheckboxTagList
            className={styles['input-margin']}
            onChange={setCheckBoxState_1}
            options={DUMMY_DATA_1}
            selectedOptions={checkBoxState_1}
          />

          <div className={styles['input-margin']}>
            <Input label={'Other'} placeholder="Enter other specifications" size="large" />
          </div>
        </div>
      </div>

      <div className={styles['row']}>
        <div className={classNames(styles['row__col'], styles['row__col--1'])}>
          <p className={classNames(styles['title-1'], 'text text--h3')}>
            Which gender, ethnicity, or other criteria do <b>you identify with</b>?
          </p>

          <p className={classNames(styles['text-1'], 'text text--body-2')}>
            Astronomic values diversity and inclusion within and outside our community. We are committed to maintaining
            an inclusive environment and equal treatment for all.
          </p>
        </div>

        <div className={classNames(styles['row__col'], styles['row__col--2'])}>
          <Checkbox
            name="test"
            value="0"
            label={"I don't identify with any of these"}
            checked={false}
            disabled={false}
          />

          <CheckboxTagList
            className={styles['input-margin']}
            onChange={setCheckBoxState_4}
            options={DUMMY_DATA_1}
            selectedOptions={checkBoxState_4}
          />

          <div className={styles['input-margin']}>
            <Input label={'Other'} placeholder="Enter how you identify" size="large" />
          </div>
        </div>
      </div>

      <div className={styles['row']}>
        <div className={classNames(styles['row__col'], styles['row__col--1'])}>
          <p className={classNames(styles['title-1'], 'text text--h3')}>
            Which <b>age range</b> are you?
          </p>

          <p className={classNames(styles['text-1'], 'text text--body-2')}>
            We've found that matching members in relevant age groups can lead to more fluid dinner conversations.
          </p>
        </div>

        <div className={classNames(styles['row__col'], styles['row__col--2'])}>
          <CheckboxTagList onChange={setCheckBoxState_2} options={DUMMY_DATA_2} selectedOptions={checkBoxState_2} />
        </div>
      </div>

      <div className={styles['row']}>
        <div className={classNames(styles['row__col'], styles['row__col--1'])}>
          <p className={classNames(styles['title-1'], 'text text--h3')}>
            Any interest in these <b>special events</b>?
          </p>

          <p className={classNames(styles['text-1'], 'text text--body-2')}>
            We'll invite you to dinner with others who share your revenue stage. To be matched differently, refill this
            form.
          </p>
        </div>

        <div className={classNames(styles['row__col'], styles['row__col--2'])}>
          <CheckboxTagList onChange={setCheckBoxState_3} options={DUMMY_DATA_3} selectedOptions={checkBoxState_3} />

          <div className={styles['input-margin']}>
            <Input label={'Other'} placeholder="Enter other event types" size="large" />
          </div>
        </div>
      </div>

      <div className={styles['row']}>
        <div className={classNames(styles['row__col'], styles['row__col--1'])}>
          <p className={classNames(styles['title-1'], 'text text--h3')}>
            <b>Become a Facilitator</b> for your Constellation Dinners
          </p>

          <p className={classNames(styles['text-1'], 'text text--body-2')}>
            Want to take a more active role? Facilitators help ensure a smooth dinner experience and get recognized as
            key contributors to our community. It's a great way to practice leadership while enjoying the evening.
          </p>
        </div>

        <div className={classNames(styles['row__col'], styles['row__col--2'])}>
          <p className={classNames(styles['label-1'], 'text text--body-2 text--bold')}>
            Are you open to be the facilitator of the dinners?
          </p>

          <RadioSwitch
            name="test2"
            onChange={setSwitchState_2}
            options={[
              { label: 'Yes', value: '0' },
              { label: 'No', value: '1' },
            ]}
            selected={switchState_2}
            className={styles['radio-switch']}
          />
        </div>
      </div>

      <MainButton className={styles['submit']} sizeType="large">
        Continue
      </MainButton>
    </form>
  );
};

export default PreferencesForm;
